import { Component, OnInit } from '@angular/core';
import { VendorTsService } from '../../../../service/vendor/vendor.ts.service';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';
import { NavigationExtras } from '@angular/router';


@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit {

  vendorList: any[] = [];

  constructor(private vendorService: VendorTsService, private router: Router) { }

  ngOnInit(): void {
    // this.vendorService.getVendorMasterList()
    //   .then(result => {
    //     this.vendorList = result.message;
    //     console.log("Vendor List",this.vendorList)
    //   })
    //   .catch(error => {
    //     console.error('Error in component:', error);
    //   });
  }

  goToVendorDetails(vendorId: string,status:string): void {
    // this.router.navigate(['/vendor-detail', vendorId]);
    const navigationExtras: NavigationExtras = {
      state: {
        businessName: vendorId,
        status:status,
      }
    };

    this.router.navigate(['/view-vendor-details',vendorId], navigationExtras);
  }
  downloadExcel(): void {
    const formattedData = this.formatDataForExcel(this.vendorList);
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(formattedData);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'VendorList');
    XLSX.writeFile(wb, 'vendor_list.xlsx');
  }

  formatDataForExcel(data: any[]): any[] {

    const formattedData = data.map(vendor => ({
      'Name': vendor.business_name,
      'Vendor Code': vendor.vendor_code,
      'Pan No':vendor.pan_no,
      'Status':vendor.status,
      'Vendor Classification':vendor.vendor_classification,
      'Turn Over Previous Year':vendor.previous_year,
      'Turn Over One Year Before Previous Year':vendor.one_year_before_previous_year,
      'Turn Over Two Years Before Previous Year':vendor.two_years_before_previous_year,
      'Legal Name':vendor.legal_name,
      'TIN No':vendor.tin_no,
      'DIN No':vendor.din_no,
      'MSME No':vendor.msme_no,
      'Aadhar No':vendor.aadhar_no,
      'Address Title': vendor.address_details.address_title,
      'Address Type': vendor.address_details.address_type,
      'Address Line': vendor.address_details.address_line_1,
      'Fax': vendor.address_details.fax,
      'City': vendor.address_details.city,
      'State': vendor.address_details.state,
      'Country': vendor.address_details.country,
      'GSTIN Number': vendor.address_details.tax_details.gstn,
      'Account Holder Registered Name': vendor.address_details.bank_detail.account_holder__registered_name,
      'Account Number': vendor.address_details.bank_detail.account_no,
      'IFSC Code': vendor.address_details.bank_detail.ifsc_code,
      'Bank Name': vendor.address_details.bank_detail.bank_name,
      'Bank Address': vendor.address_details.bank_detail.bank_address,
      'Contact Person Name': vendor.address_details.contact_person.name1,
      'Phone Number': vendor.address_details.contact_person.phone_no,
      'Mobile Number': vendor.address_details.contact_person.mobile_no,
      'Email ID': vendor.address_details.contact_person.e_mail_id,
      'Website URL': vendor.address_details.contact_person.website_url,
    }));
    return formattedData;
  }
}

